import src from "IMAGE";
export default { src, width: 70, height: 75 }
